import 'react-app-polyfill/stable';
import React, { Fragment } from 'react';
import { theme } from '@met/react-components';
import '@met/react-components/dist/polyfill';
import { ConnectedRouter } from 'connected-react-router';
import { ThemeProvider } from "styled-components";
import IntlProvider from './containers/IntlProvider';
import './appinsights';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import App from './App';
import './fontAwesome';
import history from './history';
import { unregister } from './registerServiceWorker';
import { configureStore } from './store';
import './styles/app.scss';
import { MsalAuthWrapper } from './msal';

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);
const rootElement = document.getElementById('root');

ReactDOM.render(
  <MsalAuthWrapper>
    <Provider store={store}>
      <IntlProvider>
        <ConnectedRouter history={history}>
          <ThemeProvider theme={theme}>
            <Fragment>
              <App />
              <ReduxToastr
                timeOut={3500}
                transitionIn='fadeIn'
                transitionOut='fadeOut'
                position='bottom-right'
                newestOnTop={false}
                preventDuplicates={true}
                closeOnToastrClick={true}
              />
            </Fragment>
          </ThemeProvider>
        </ConnectedRouter>
      </IntlProvider>
    </Provider>
  </MsalAuthWrapper>, rootElement);

unregister();